export default __webpack_public_path__ + "static/media/bg-global012.500c4b4f.png";